import React, { useEffect } from "react";
import { Text } from "@chakra-ui/react";
import { populateEnv } from "services/environment";
import FullPageSpinner from "./FullPageSpinner";

export default function AuthError() {
  useEffect(() => {
    const timeout = setTimeout(() => {
      window.location.assign(populateEnv().baseUrl + `login?logout=true`);
    }, 300);

    return () => clearTimeout(timeout);
  });

  return (
    <FullPageSpinner>
      <Text color="white" fontSize="2xl">
        Authenticating...
      </Text>
    </FullPageSpinner>
  );
}
